import AclName from '../AclName';

export default [
  AclName.BookkeepingEvidencesAccessAll,
  AclName.BookkeepingPageDeclarationsVatList,
  AclName.BookkeepingPageZusCompanySettlementsList,

  AclName.CrmPageBillingList,
  AclName.CrmPageBillingSettle,
  AclName.CrmPageBankingOperationsList,
  AclName.CrmPageBankingOperationsSettle,
  AclName.CrmPageMailingList,
  AclName.CrmPageMailingStepper,
  AclName.CrmBtnMailingDelete,
  AclName.CrmBtnMailingEdit,
  AclName.CrmBtnMailingSendNow,
  AclName.MailingSettingsBtnSave,
  AclName.StaffPageAccidentInsurancesList,
  AclName.StaffPageAccidentInsurancesEdit,
];
